import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SitesBuilderRoutingModule } from './sites-builder.routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { SbClientModule } from './sb-client/sb-client.module';
import { SitesbuilderComponent } from './sites-builder.component';
import { SubmenuModule } from '../layout/submenu/submenu.module';
import { SbManagerModule } from './sb-manager/sb-manager.module';

@NgModule({
  declarations: [SitesbuilderComponent],
  imports: [
    SitesBuilderRoutingModule,
    SbClientModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SubmenuModule,
    SbManagerModule,
    NgMultiSelectDropDownModule.forRoot(),
  ],
  providers: [],
})
export class SitesBuilderModule {}
